import * as React from "react";
import isEqual from "lodash/isEqual";
import { Selectors, Types, Actions } from "@grandvisionhq/auth";
import { toast } from "@grandvisionhq/common";
import { useDispatch, useSelector, useIntl } from "@grandvisionhq/state";
import { changeFormValue } from "../../../../../../actions.js";
import { usePersonalDetailsFormSlots } from "../../../../../../slots/slots/PersonalDetailsFormSlotsContext.js";
import { toggleFormEditMode } from "../../../../../Profile/actions.js";
import { usePersonalDetails } from "../../../../../hooks/Profile/hooks/use-personal-details.js";
import { toPersonalDetails, mapFormStateToPersonalDetailsType } from "../../../../../mappers/Profile/mappers/profile.js";
import { getPersonalDetails } from "../../../../../Profile/selectors.js";
import { ErrorAlert } from "../../../../Profile/components/ErrorAlert.js";
import { LoadingData } from "../../../../Profile/components/LoadingData.js";
import PersonalDetails from "./PersonalDetails.js";
const FORM_NAME = Types.FormName.personalDetails;
const PersonalDetailsContainer = (props) => {
  const dispatch = useDispatch();
  const auth = useSelector(Selectors.getAuth);
  const intl = useIntl();
  const userId = useSelector(Selectors.getUserId);
  const formState = useSelector(
    getPersonalDetails,
    (previousState, newState) => isEqual(previousState, newState)
  );
  const { Slots } = usePersonalDetailsFormSlots();
  const openEditMode = React.useCallback(
    () => dispatch(
      toggleFormEditMode({
        formName: Types.FormName.personalDetails,
        inEditMode: true
      })
    ),
    [dispatch]
  );
  const closeEditMode = React.useCallback(
    () => dispatch(
      toggleFormEditMode({
        formName: Types.FormName.personalDetails,
        inEditMode: false
      })
    ),
    [dispatch]
  );
  const onCompleted = React.useCallback(
    ({ reason, data }) => {
      if (reason === "QUERY") {
        dispatch(
          Actions.UserDataActions.fetchUserDataSuccess({
            [FORM_NAME]: toPersonalDetails(data.me?.personalDetails)
          })
        );
      }
      if (reason === "MUTATION") {
        dispatch(
          Actions.UserDataActions.updateUserDataSuccess({
            formName: FORM_NAME,
            server: {
              [FORM_NAME]: toPersonalDetails(data.updateB2CPersonalDetails?.personalDetails)
            }
          })
        );
        toast.success("account.updateProfile.success");
      }
      closeEditMode();
    },
    [dispatch, closeEditMode]
  );
  const onError = React.useCallback(
    ({ reason, error }) => {
      if (reason === "QUERY") {
        dispatch(Actions.UserDataActions.fetchUserDataFailed(error));
      }
      if (reason === "MUTATION") {
        dispatch(Actions.UserDataActions.updateUserDataFailed({ error, formName: FORM_NAME }));
        toast.failed("account.profile.settings.saveFailed");
      }
    },
    [dispatch]
  );
  const { personalDetailsData, isFetching, isUpdating, updatePersonalDetails, fetchError } = usePersonalDetails({
    onCompleted,
    onError
  });
  if (isFetching || !userId) {
    return /* @__PURE__ */ React.createElement(LoadingData, null);
  }
  if (fetchError) {
    return /* @__PURE__ */ React.createElement(
      ErrorAlert,
      {
        message: intl.getFormattedLabel("account.personalDetails.errors.network.general", {
          parseLink: true
        })
      }
    );
  }
  const handleFormChange = (form) => {
    dispatch(changeFormValue({ form }));
  };
  const handleSavePersonalDetails = async () => {
    if (formState?.state.formValid) {
      const newData = mapFormStateToPersonalDetailsType(formState.state.formState);
      await updatePersonalDetails(newData, userId);
    }
  };
  const personalDetailsLabels = {
    add: intl.getLabel("account.profile.personalDetails.add"),
    close: intl.getLabel("common.actions.cancel"),
    contact: intl.getFormattedLabel("account.profile.customerCare", {
      parseLink: true,
      parseHTML: true
    }),
    email: intl.getLabel("checkout.contact.email"),
    intro: intl.getLabel("account.profile.personalDetails.intro"),
    modalInfo: intl.getLabel("account.profile.settings.modal.info"),
    modalTitle: intl.getLabel("account.profile.personalDetails.edit"),
    noDetails: intl.getLabel("account.profile.personalDetails.noDetails"),
    save: intl.getLabel("account.action.save")
  };
  return /* @__PURE__ */ React.createElement(
    PersonalDetails,
    {
      ...props,
      Slots,
      hasNoData: Object.values(personalDetailsData).every((x) => x === null || x === ""),
      labels: personalDetailsLabels,
      email: auth.email,
      isUpdating,
      personalDetailsData,
      formState,
      handleFormChange,
      handleSavePersonalDetails,
      toggleEditMode: openEditMode,
      closeEditMode
    }
  );
};
export {
  PersonalDetailsContainer as default
};
//# sourceMappingURL=PersonalDetailsContainer.js.map
